import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import appConfig from '../../../config.js';
import moment from 'moment';
import Table from '../../commons/Table/Table';
import Modal from '../../commons/Modal/Modal';
import { TextInputField, MultiplePhoneField, MultipleEmailField, SchedulePicker } from '../../commons/Inputs';
import FloatingActionButton from '../../commons/Buttons/FloatingActionButton';

import {
    getBranchesApi
} from '../../actions/branches';

let $ = window.jQuery;
let Bloodhound = window.Bloodhound;

class Clinics extends Component {
    static propTypes = {
        getBranchesApi: PropTypes.func.isRequired,
        session: PropTypes.object.isRequired
    };


    state = {
        data : [],
        headers : [
            {key : 'name', label : 'Name'},
            {key : 'address', label : 'Address'},
            {key : 'services', label: 'Services'},
            {key : 'actions', label : 'Actions'}
        ],
        isSavingClinic : false,
        isEditingClinic: false,
        id: '',
        name: '',
        address_line: '',
        barangay: '',
        city: '',
        province: '',
        zip_code: '',
        schedule: [],
        startTime: '',
        endTime: '',
        schedules: [{
            'day':'',
            'start_time':'',
            'end_time':''
        }],
        phone_numbers: [{
            'number':'',
            'type':''
        }],
        email_addresses: [{'emailAddress':''}],
        days: [
            {
                value: '',
                label: 'Select a day',
                disabled: false
            }, {
                value: 0,
                label: 'Sunday',
                disabled: false
            }, {
                value: 1,
                label: 'Monday',
                disabled: false
            }, {
                value: 2,
                label: 'Tuesday',
                disabled: false
            }, {
                value: 3,
                label: 'Wednesday',
                disabled: false
            }, {
                value: 4,
                label: 'Thursday',
                disabled: false
            }, {
                value: 5,
                label: 'Friday',
                disabled: false
            }, {
                value: 6,
                label: 'Saturday',
                disabled: false
            },
        ],
        services: [],
        searchedServices: [],
        errors: []
    }

    handleFABClick = () => {
        $('#clinicModal').modal('show');
    }

    componentDidMount() {
        this.getAllClinics();

        let self = this;

        $('#services').tagsinput({
            freeInput: true,
            typeaheadjs: {
                source: self.state.searchedServices,
            }
        });
    }

    componentWillMount() {
        var searchedServices = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: appConfig.apiUrl + 'management/branches/services?q=%QUERY',
                wildcard: '%QUERY',
                filter: function(response) {
                    return response.data;
                }
            }
        });

        this.setState({searchedServices});
    }

    generateTableActions(id){
        let html = (
            <div className="">
                <button href="#"
                        className='btn btn-xs tooltips blue'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Edit'
                        onClick={this.handleEditClinic}
                        data-id={id}>
                    <i className='glyphicon glyphicon-edit'
                       data-id={id}></i>
                </button>
                <button href="#"
                        className='btn btn-xs tooltips deletePopover red'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Delete'
                        data-id={id}
                        data-toggle="confirmation"
                        data-singleton="true">
                    <i className='glyphicon glyphicon-remove'
                       data-id={id}></i>
                </button>
            </div>
        )
        return html;
    }

    getAllClinics = () => {
        let url = appConfig.apiUrl + 'management/branches';

        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let displayData = res.data.data;

            displayData.forEach((row) => {
                row.schedules = row.schedule;
                row.phone_numbers = row.facility_phone_number.length > 0 ? row.facility_phone_number : [{'number':''}];
                row.email_addresses = row.facility_email_addresses.length > 0 ? row.facility_email_addresses : [{'emailAddress':''}];
                // console.log(row);
                row.address = row.address_line + " " + row.barangay + " " + row.city + " " + row.province + " " + row.zip_code;
                row.actions = this.generateTableActions(row.id);
            });

            this.setState({
                data : displayData
            }, (e) => {
                $('#table').dataTable();
                $('.tooltips').tooltip();

                let self = this;

                $('.deletePopover').confirmation({
                    title: 'Are you sure to delete this Clinic?',
                    popout: true,
                    btnOkClass: 'btn btn-primary btn-sm',
                    btnCancelClass: 'btn btn-danger btn-sm',
                    container: 'body',
                    onConfirm: function() {
                        let clinicId = $(this).data('id');
                        self.deleteClinic(clinicId);
                    }
                });
            });

            console.log('getting branches');
            this.props.getBranchesApi();
        }).catch((res) => {
            // display error
        });
    }

    handleSaveClinic = () => {
        // disable modal buttons
        this.setState({
            isSavingClinic : true,
        });
        let url = appConfig.apiUrl + (this.state.isEditingClinic ? 'management/branches/update/'+this.state.id : 'management/branches');
        let clinic = $('#clinicForm').serializeArray();
        clinic.push({name:'id', value:this.state.id});

        let schedules = this.state.schedules;
        schedules.forEach((row, i) => {
            clinic.push({name:'schedules['+i+'][day]', value:row.day});
            clinic.push({name:'schedules['+i+'][start_time]', value: moment(row.start_time, 'hh:mm A').format('HH:mm:ss')});
            clinic.push({name:'schedules['+i+'][end_time]', value: moment(row.end_time, 'hh:mm A').format('HH:mm:ss')});
        });

        axios({
            url: url,
            timeout: 20000,
            method: 'post',
            data: window.jQuery.param(clinic)
        }).then((res) => {

            // enable modal buttons again
            this.setState({
                isSavingClinic : false
            }, (e) => {
                // destroy table
                $('#table').dataTable().fnDestroy();

                // refresh table
                this.getAllClinics();
            });

            // clear form
            this.setState({
                isEditingClinic: false,
            }, (e) => {

                // close modal
                $('#clinicModal').modal('toggle');
                this.clearForm();
            })
        }).catch((error) => {
            let fields = Object.keys(error.response.data.errors);

            let errors = this.state.errors;
            fields.forEach((item) => {
                errors[item] = true;
            });

            this.setState({
                errors,
                isSavingClinic : false
            });
        });
    }

    handleEditClinic = (e) => {
        let id = parseInt(e.target.dataset.id, 10);
        let index = this.state.data.findIndex((item) => item.id === id);
        let clinic = this.state.data[index];
        if(clinic) {
            this.setState({
                isEditingClinic : true,
                id: clinic.id,
                name: clinic.name,
                address_line: clinic.address_line,
                barangay: clinic.barangay,
                city: clinic.city,
                province: clinic.province,
                zip_code: clinic.zip_code,
                schedules: clinic.schedules.length > 0 ? clinic.schedules: [{'day':'','start_time':'','end_time':''}],
                phone_numbers: clinic.facility_phone_number.length > 0 ? clinic.facility_phone_number : [{'number':'','type':''}],
                email_addresses: clinic.facility_email_addresses.length > 0 ? clinic.facility_email_addresses : [{'emailAddress':''}]
            }, (e) => {
                $('#services').tagsinput('add', clinic.services);
                $('#clinicModal').modal('toggle');
            })
        }

    }

    deleteClinic = (id) => {
        let url = appConfig.apiUrl + 'management/branches/'+id;
        console.log(url)

        axios({
            url: url,
            timeout: 20000,
            method: 'post',
            data: {'_method': 'DELETE'}
        }).then((res) => {

            // destroy table
            $('#table').dataTable().fnDestroy();

            // refresh table
            this.getAllClinics();
        }).catch((res) => {
            // display error
        });
    }

    handleCloseModal = () => {
        this.clearForm();
    }

    clearForm = () => {
        $('#services').tagsinput('removeAll');
        $('.md-check').prop("checked", false);

        this.setState({
            isEditingClinic: false,
            id: '',
            name: '',
            address_line: '',
            barangay: '',
            city: '',
            province: '',
            zip_code: '',
            schedules: [{
                'day': '',
                'start_time': '',
                'end_time': '',
            }],
            phone_numbers: [{
                'number':'',
                'type':''
            }],
            email_addresses: [{'emailAddress':''}],
            services: '',
            errors: []
        });
    }

    handlePhones = (e) => {
        e.preventDefault();
        let element = $(e.target);

        if(element.hasClass('addPhone')) {
            if(element.parents('.perContainer').find('.phoneInput').val().trim() === '') {
                element.parents('.perContainer').find('.phoneInput').focus();
                return false;
            }

            element.attr('class',' fa fa-times removePhone');

            let phoneInputs = {
                'number': '',
                'phone_type_id': 1
            };
            let phone_numbers = this.state.phone_numbers;
            phone_numbers.push(phoneInputs);

            this.setState({
                phone_numbers
            })

        } else if(element.hasClass('removePhone')) {
            let index = element.parents('.perContainer')[0].dataset.index;

            let phone_numbers = this.state.phone_numbers;
            phone_numbers.splice(index, 1);

            this.setState({
                phone_numbers
            })
        }
    }

    updatePhoneArray = (index, number, phone_type_id) => {
        let phone_numbers = this.state.phone_numbers;
        phone_numbers[index] = {
            number, phone_type_id
        }
        this.setState({
            phone_numbers
        })
    }

    handleEmails = (e) => {
        e.preventDefault();
        let element = $(e.target);

        if(element.hasClass('addEmail')) {
            if(element.parents('.perContainer').find('.emailInput').val().trim() === '') {
                element.parents('.perContainer').find('.emailInput').focus();
                return false;
            }

            element.attr('class',' fa fa-times removeEmail');

            let emailInputs = '';
            let email_addresses = this.state.email_addresses;
            email_addresses.push(emailInputs);

            this.setState({
                email_addresses
            })

        } else if(element.hasClass('removeEmail')) {
            let index = element.parents('.perContainer')[0].dataset.index;

            let email_addresses = this.state.email_addresses;
            email_addresses.splice(index, 1);

            this.setState({
                email_addresses
            })
        }
    }

    updateEmailArray = (index, emailAddress) => {
        let email_addresses = this.state.email_addresses;
        email_addresses[index] = {emailAddress};
        this.setState({
            email_addresses
        })
    }

    handleSchedules = (e) => {
        e.preventDefault();
        let element = $(e.target);

        if(element.hasClass('addSchedule')) {

            element.attr('class',' fa fa-times removeSchedule');

            let scheduleInputs = {
                'day': '',
                'start_time': '',
                'end_time': ''
            };
            let schedules = this.state.schedules;
            schedules.push(scheduleInputs);

            this.setState({
                schedules
            })

        } else if(element.hasClass('removeSchedule')) {
            let index = element.parents('.perContainer')[0].dataset.index;

            let schedules = this.state.schedules;
            schedules.splice(index, 1);

            this.setState({
                schedules
            })
        }
    }

    updateScheduleArray = (index, day, start_time, end_time) => {
        let schedules = this.state.schedules;
        schedules[index] = {
            day, start_time, end_time
        }
        this.setState({
            schedules
        })
    }

    updateDays = () => {
        let schedules = this.state.schedules;
        let days = this.state.days;

        days.forEach((day, i) => {
            days[i] = {
                ...days[i],
                disabled: false
            }
            schedules.forEach((schedule) => {
                if(parseInt(day.value,10) === parseInt(schedule.day,10)) {
                    days[i] = {
                        ...days[i],
                        disabled: true
                    }
                }
            })
        })

        this.setState({
            days
        })
    }

    render() {
        if(!this.state.phone_numbers) {
            let phone_numbers = [{'number':''}];
            this.setState({
                phone_numbers
            })
        }
        if(!this.state.email_addresses) {
            let email_addresses = [{'emailAddress':''}];
            this.setState({
                email_addresses
            })
        }

        return(
            <div className="page-content">

                <div className="row">
                    <div className="col-md-12">
                        <h3 className="page-title">
                            Management &nbsp; <small>Clinics</small>
                        </h3>
                    </div>
                </div>

                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="portlet light portlet-fit">
                        <div className="portlet-title">
                            <div className="caption">
                                <i className=" icon-heart font-blue" />
                                <span className="caption-subject font-blue sbold uppercase">Clinics</span>
                            </div>
                        </div>
                        <div className="portlet-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-scrollable">
                                        <Table id={"table"} headers={this.state.headers} data={this.state.data} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <FloatingActionButton
                            title="Add Clinic"
                            onClick={this.handleFABClick} />
                    </div>
                </div>

                <Modal
                    id="clinicModal"
                    header="Add Clinic"
                    onNegativeClickEvent={this.handleCloseModal}
                    onPositiveClickEvent={this.handleSaveClinic}
                    isSaving={this.state.isSavingClinic}>

                    <div className="row">
                        <div id="alert-modal-container-clinic" style={{ paddingRight: '20px', paddingLeft: '20px' }}></div>
                        <div className="col-md-12">
                            <form id="clinicForm">
                                <div className="row">
                                    <div className="col-md-12">
                                        <TextInputField id="name" label="Branch name *"
                                                        help=""
                                                        onChange={(e) => {this.setState({name: e.target.value})}}
                                                        val={this.state.name}
                                                        hasError={this.state.errors.name} />
                                        <TextInputField id="address_line" label="Address street"
                                                        help=""
                                                        onChange={(e) => {this.setState({address_line: e.target.value})}}
                                                        val={this.state.address_line} />
                                    </div>
                                    <div className="col-md-6">
                                        <TextInputField id="barangay" label="Barangay/District"
                                                        help=""
                                                        onChange={(e) => {this.setState({barangay: e.target.value})}}
                                                        val={this.state.barangay} />
                                        <TextInputField id="city" label="City"
                                                        help=""
                                                        onChange={(e) => {this.setState({city: e.target.value})}}
                                                        val={this.state.city} />
                                    </div>
                                    <div className="col-md-6">
                                        <TextInputField id="province" label="Province"
                                                        help=""
                                                        onChange={(e) => {this.setState({province: e.target.value})}}
                                                        val={this.state.province} />
                                        <TextInputField id="zip_code" label="Zipcode"
                                                        help=""
                                                        onChange={(e) => {this.setState({zip_code: e.target.value})}}
                                                        val={this.state.zip_code} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group form-md-line-input">
                                            <input type="text" className="form-control" id="services"
                                                   name="services"
                                                   onChange={(e) => {this.setState({services: e.target.value})}}
                                                   value={this.state.services}
                                                   data-role="tagsinput"/>

                                            <label htmlFor="services">Services</label>
                                            <span className="help-block">Services</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <hr />
                                    <div className="col-md-12 parent_content" onClick={this.handleSchedules}>
                                        {this.state.schedules.map((schedule, i) => {
                                            return <SchedulePicker key={i} index={i} totalIndex={this.state.schedules.length}
                                                                   val={schedule.day} startTime={schedule.start_time} endTime={schedule.end_time} days={this.state.days}
                                                                   dayId={"schedules[" +i+ "][day]"} startTimeId={"schedules[" +i+ "][start_time]"} endTimeId={"schedules[" +i+ "][end_time]"}
                                                                   label="Day" help="Day" type="text"
                                                                   updateDays={this.updateDays}
                                                                   updateScheduleArray={this.updateScheduleArray} />
                                        })}
                                    </div>
                                </div>
                                <div className="row">
                                    <hr />
                                    <div className="col-md-12 parent_content" onClick={this.handlePhones}>
                                        {this.state.phone_numbers.map((phone, i) => {
                                            return <MultiplePhoneField key={i} index={i} totalIndex={this.state.phone_numbers.length}
                                                                       val={phone.number} phoneType={phone.phone_type_id}
                                                                       numberId={"phone_numbers[" +i+ "][number]"} typeId={"phone_numbers[" +i+ "][type]"} label="Phone" help="Phone" type="text"
                                                                       updatePhoneArray={this.updatePhoneArray} />
                                        })}
                                    </div>
                                </div>
                                <div className="row">
                                    <hr />
                                    <div className="col-md-12 parent_content" onClick={this.handleEmails}>
                                        {this.state.email_addresses.map((email, i) => {
                                            return <MultipleEmailField key={i} index={i} totalIndex={this.state.email_addresses.length}
                                                                       val={email.emailAddress} id="email_addresses[][emailAddress]" label="Email" help="Email" type="text"
                                                                       updateEmailArray={this.updateEmailArray} />
                                        })}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        session: state.session
    }
};

export default connect(mapStateToProps, {
    getBranchesApi
})(Clinics);



/** WEBPACK FOOTER **
 ** ./src/containers/Clinics/index.js
 **/